import * as Factory from 'factory.ts'
import faker from 'faker'

import { type Approver, type VendorApprovalGroupApprover } from '@webapp/models'
import { SimpleApprovalGroupMock } from './approvalGroup.factory'
import { SimpleUserMock } from './user.factory'

export const ApproverMock = Factory.Sync.makeFactory<Approver>({
  group: SimpleApprovalGroupMock.build(),
  id: Factory.each(() => faker.random.number()),
  level_text: '(level 1)',
  sequence: Factory.each(() => faker.random.number()),
  threshold: Factory.each(() => faker.commerce.price()),
  user: Factory.each(() => SimpleUserMock.build()),
  user_id: Factory.each(() => faker.random.number()),
  vacation_active: false,
}).withDerivation1(['user'], 'user_id', (user) => user.id)

export const VendorApproverMock =
  Factory.Sync.makeFactory<VendorApprovalGroupApprover>({
    id: Factory.each(() => faker.random.number()),
    level_text: Factory.each((index) => `(level ${index + 1})`),
    sequence: Factory.each((index) => index + 1),
    user: Factory.each(() => SimpleUserMock.build()),
    user_id: Factory.each(() => faker.random.number()),
  }).withDerivation1(['user'], 'user_id', (user) => user.id)
